import type { UndoRedoResponse } from '@/app/quadratic-core-types';
import type { SnackbarOptions } from '@/shared/components/GlobalSnackbarProvider';

/**
 * Handles the structured response from undo/redo operations.
 * Shows a snackbar warning if code is currently running.
 *
 * @param response - The response from undo/redo operation
 * @param snackbar - The snackbar function to call for displaying messages
 */
export function handleUndoRedoResponse(
  response: UndoRedoResponse | undefined,
  snackbar: (message: string, options: SnackbarOptions) => void
): void {
  if (response?.type === 'CodeRunning') {
    snackbar('Undo/redo is not available while code is running', { severity: 'warning' });
  }
  // NoUndoAvailable and NoRedoAvailable are intentionally handled silently
  // since these are expected states (e.g., empty undo/redo stack).
}
